import { useShop, money } from "../lib/shop";
import { Store, Truck, PackageCheck } from "lucide-react";

export const FULFILMENT_LABELS = {
    collection: "Click & Collect",
    local_delivery: "Local Delivery",
    courier_delivery: "Courier Delivery",
};

export const FulfilmentPicker = ({ value, onChange, testIdPrefix }) => {
    const { basket, settings } = useShop();

    const options = [
        {
            key: "collection",
            label: "Click & Collect",
            desc: "Free · collect from Whitley Street",
            icon: Store,
            globallyEnabled: settings.collection_enabled,
        },
        {
            key: "local_delivery",
            label: "Local Delivery",
            desc: `${money(settings.delivery_fee)} · free over ${money(settings.free_delivery_over)}`,
            icon: Truck,
            globallyEnabled: settings.delivery_enabled,
        },
        {
            key: "courier_delivery",
            label: "Courier Delivery",
            desc: `${money(settings.courier_fee)} flat`,
            icon: PackageCheck,
            globallyEnabled: settings.courier_delivery_enabled,
        },
    ];

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" role="radiogroup" aria-label="Fulfilment method">
            {options.map((opt) => {
                const blockedItems = basket.filter((i) => i[`allow_${opt.key}`] === false).map((i) => i.name);
                const enabled = opt.globallyEnabled && blockedItems.length === 0;
                return (
                    <button
                        key={opt.key}
                        type="button"
                        role="radio"
                        aria-checked={value === opt.key}
                        disabled={!enabled}
                        data-testid={`${testIdPrefix}-${opt.key}`}
                        onClick={() => onChange(opt.key)}
                        title={
                            !opt.globallyEnabled
                                ? "Currently unavailable"
                                : blockedItems.length
                                  ? `Not available for: ${blockedItems.join(", ")}`
                                  : opt.label
                        }
                        className={`rounded-xl px-3 py-3 text-left border-2 transition-colors ${
                            value === opt.key && enabled
                                ? "border-[#0033A0] bg-[#0033A0] text-white"
                                : enabled
                                  ? "border-slate-200 text-slate-600 hover:border-[#0033A0]"
                                  : "border-slate-100 text-slate-300 cursor-not-allowed bg-slate-50"
                        }`}
                    >
                        <span className="flex items-center gap-1.5 font-heading font-bold text-sm">
                            <opt.icon className="h-4 w-4" /> {opt.label}
                        </span>
                        <span className={`block text-xs mt-0.5 ${value === opt.key && enabled ? "text-blue-100" : enabled ? "text-slate-400" : "text-slate-300"}`}>
                            {!opt.globallyEnabled ? "Unavailable" : blockedItems.length ? `Not for ${blockedItems[0]}${blockedItems.length > 1 ? ` +${blockedItems.length - 1}` : ""}` : opt.desc}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};
